/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';

import { DecisionPoint }           from '@/models/scenario/decision.point';
import {ICellRenderer, ICellRendererParams} from "ag-grid-community";

/**
 *
 * @class WorkDecisionPointRenderer
 *
 * @brief cell rendering for decision points (physical locations)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class WorkDecisionPointRenderer implements ICellRenderer {

  /** agGrid DOM element for display */
  public gui: HTMLElement;

  /** the value being rendered */
  public value: DecisionPoint;

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    this.gui = document.createElement('div');
    this.gui.innerHTML = `<span style="color: grey;">Mile Post...</span>`;

    /* render! */

    this.refresh(params);
  }

  /** return the currently rendered DOM */
  public getGui(): HTMLElement {

    return this.gui;
  }

  /** update the rendered DOM */
  public refresh(params: ICellRendererParams): boolean {

    this.value         = null;
    this.gui.innerHTML = `<span style="color: grey;">Mile Post...</span>`;

    if (params.value instanceof DecisionPoint) {

      this.value = params.value;
    }

    if (!this.value) {

      /* nothing to do */

      return true;
    }

    let   name = this.value._name.trim();
    const mile = this.value._mileage.toFixed(2);

    if (name.length >= 16) {

      name = name.substring(0, 16) + '...';
    }

    this.gui.innerHTML = `<i>${name}</i> - ${mile}&nbsp;mi`;

    return true;
  }

  /** destructor for rendered DOM */
  public destroy() {

  }

}
